import { ReactElement, useEffect, useState } from "react";
import { Breadcrumb, Button, Layout, Space, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BreadCrumbWrapper, RightButton } from "../../components/GlobalStyles";
import { CreateCourtDrawer } from "./CreateCourtDrawer";
import { DeleteCourtModal } from "./DeleteCourtModal";
import { EditCourtDrawer } from "./EditCourtDrawer";
import {
  getAuthState,
  getClubState,
  getBranchState,
  getCourtState,
} from "../../redux/selectors";
import { FETCH_ALL_COURTS_REQUEST } from "../../redux/constants";

const { Content } = Layout;
export function Branch(): ReactElement {
  const dispatch = useDispatch();
  const { courts } = useSelector(getCourtState);
  const { clubs } = useSelector(getClubState);
  const { branches } = useSelector(getBranchState);
  const { currentUser } = useSelector(getAuthState);
  const { clubId, branchId } = useParams<{
    clubId: string;
    branchId: string; // firestoreRef
  }>();
  const [createCourtDrawerVisible, setCreateCourtDrawerVisible] = useState(false);
  const [editCourtDrawerVisible, setEditCourtDrawerVisible] = useState(false);
  const [deleteCourtModalVisible, setDeleteCourtModalVisible] = useState(false);
  const [selectedCourt, setSelectedCourt] = useState<any>();
  const { t } = useTranslation();
  const history = useHistory();
  const { name } = clubs.filter((club) => club.key === clubId)[0];
  const { location } = branches.filter((branch) => branch.firestoreRef === branchId)[0];

  useEffect(() => {
    dispatch({
      type: FETCH_ALL_COURTS_REQUEST,
      payload: { currentUser, clubId, branchId },
    });
  }, []);

  const onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    // eslint-disable-next-line no-console
    console.log("params", pagination, filters, sorter, extra);
  };

  const onEdit = (record: any) => {
    setEditCourtDrawerVisible(true);
    setSelectedCourt(record);
  };

  const onDelete = (record: any) => {
    setDeleteCourtModalVisible(true);
    setSelectedCourt(record);
  };

  const goToBookings = (record: any) => {
    history.push(
      `/clubs/${clubId}/bookings?branch=${branchId}&court=${record.courtId}`
    );
  };

  const columns: any = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("court.court_place"),
      key: "place",
      render: ({ place }: any) => <span>{t(`court.${place}`)}</span>,
    },
    {
      title: t("court.description"),
      dataIndex: "description",
      key: "description",
    },
    {
      title: t("common.action"),
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <Button onClick={() => onEdit(record)}>{t("common.edit")}</Button>
          <Button danger onClick={() => onDelete(record)}>
            {t("common.delete")}
          </Button>
          <Button onClick={() => goToBookings(record)}>Bookings</Button>
        </Space>
      ),
    },
  ];

  return (
    <Content>
      <BreadCrumbWrapper>
        <Breadcrumb style={{ fontSize: 16 }}>
          <Breadcrumb.Item>
            <a href="/clubs">{t("club.clubs")}</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a href={`/clubs/${clubId}`}>{name}</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{location}</Breadcrumb.Item>
        </Breadcrumb>
        <RightButton
          type="primary"
          onClick={() => setCreateCourtDrawerVisible(true)}
        >
          {t("common.add")}
        </RightButton>
      </BreadCrumbWrapper>
      <Table
        columns={columns}
        dataSource={courts}
        onChange={onChange}
        rowKey="courtId"
      />
      <CreateCourtDrawer
        visible={createCourtDrawerVisible}
        onClose={() => setCreateCourtDrawerVisible(false)}
      />
      {selectedCourt && (
        <EditCourtDrawer
          visible={editCourtDrawerVisible}
          onClose={() => {
            setSelectedCourt(null);
            setEditCourtDrawerVisible(false);
          }}
          court={selectedCourt}
        />
      )}
      {selectedCourt && (
        <DeleteCourtModal
          visible={deleteCourtModalVisible}
          onClose={() => {
            setSelectedCourt(null);
            setDeleteCourtModalVisible(false);
          }}
          court={selectedCourt}
        />
      )}
    </Content>
  );
}
